import { EnumAuthContext } from "../store/modules/auth/actions";

export function chooseTypeFromContext(context: EnumAuthContext) {
    switch(context) {
        case EnumAuthContext.BACKOFFICE:
            return 'admin';
        default:
            return 'parceiro';
    }
}